import get from "lodash/get";
import { v4 as uuidv4 } from "uuid";

import {
  SET_USER_PROFILE,
  SIGN_OUT,
  SET_SESSION_ID
} from "../types";
export const initialState = {
  userId: "",
  email: "",
  groups: [],
  sessionId: uuidv4()
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_PROFILE:
      return {
        ...state,
        ...get(action, "payload", {})
      };
    case SIGN_OUT:
      return {
        ...state,
        ...initialState,
      };
    case SET_SESSION_ID:
      return {
        ...state,
        sessionId: action.sessionId
      };
    default:
      return state;
  }
};

export default reducer;
